import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const salesTaxPermissionsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'salesTax'] as const;
  return createQueryKey({
    all: key,
    unitType: <U extends QueryKeyParam>(unitType: U) =>
      createQueryKey({
        all: [...key, unitType] as const,
        detail: [...key, 'detail'] as const,
      }),
  });
};
export { salesTaxPermissionsKeys };
